import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";

export const GET_PAYMENT_METHODS = "[PAYMENT_METHOD] GET_ALL";
export const GET_PAYMENT_METHODS_SUCCESS = "[PAYMENT_METHOD] GET_ALL_SUCCESS";
export const GET_PAYMENT_METHODS_FAILED = "[PAYMENT_METHOD] GET_ALL_FAILED";

export const SET_VALUE = "[PAYMENT_METHOD] SET_VALUE";
export const CLEAR_VALUES = "[PAYMENT_METHOD] CLEAR_VALUES";

export function setValue(payload: any) {
	return (dispatch: any) => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getPaymentMethods(callback?: Callback<any>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_PAYMENT_METHODS });

		try {
			const { login } = getState();

			const response = await api.sendGet("/PaymentMethod", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_PAYMENT_METHODS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_PAYMENT_METHODS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_PAYMENT_METHODS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
